import { createContext, useContext } from 'react';
import defaultBackground from '../Header/assets/background.png';

export type TAdfoxLoadPayload = {
  bgImageUrl?: string;
  label?: string;
};

export type TBackgroundContext = {
  imageUrl: string | undefined;
  defaultImageUrl: string;
  isBackgroundShown: boolean;
  label: string | undefined;
  onAdfoxLoad: (payload: TAdfoxLoadPayload) => void;
  onAdfoxStub: () => void;
};

export const BackgroundContext = createContext<TBackgroundContext>({
  imageUrl: undefined,
  defaultImageUrl: defaultBackground,
  isBackgroundShown: false,
  label: undefined,
  onAdfoxLoad: () => {},
  onAdfoxStub: () => {},
});

export const useBackgroundContext = () => useContext(BackgroundContext);
